import React, { useContext } from 'react'
import { CSVLink } from "react-csv";

//custom imports
import styles from '../../../assets/stylesheets/pages/caller/roster.module.scss'
import { DownloadIcon } from '../../../assets/images';
import { BulkActionContext } from './bulkActionContext';
import CustomTooltip from '../../../components/utilities/ToolTip';

const CSVSchema = () => {
    const defaultSchema = [{ label: "mobile", key: "mobile" }]
    const { currentAction, OFFER_LETTER, ADD_BASE_PAY, CERTIFY_AGENT, MATCH_AGENT, BULK_MODERATION_MANUAL_GRADES } = useContext(BulkActionContext)
    let fileName = ''
    const optionalHeaders = ["crmlink", "source"]
    const getSchema = () => {
        switch (currentAction.value) {
            case OFFER_LETTER:
                fileName = 'onboarding_upload_offer_letter_for_agents'
                return {
                    headers: [...defaultSchema, {label: "url", key: "url"}],
                    data: [
                        {mobile: "9123456786", url: "http://example.com"}
                    ]
                }
            case ADD_BASE_PAY:
                fileName = 'onboarding_upload_earnings_for_agents'
                return {
                    headers: [...defaultSchema, {label: "earnings", key: "earnings"}],
                    data: [
                        {mobile: "9123456786", earnings: "500"}
                    ]
                }
            case CERTIFY_AGENT:
                fileName = 'onboarding_upload_agents_to_certify'
                return {
                    headers: [...defaultSchema, 
                        {label: "languages", key: "languages"},
                        {label: "crmlink", key: "crmlink"},
                        {label: "source", key: "source"},
                        {label: "recruiter", key: "recruiter"}
                    ],
                    data: [
                        {mobile: "9123456786", languages: "hindi;english", crmlink: "http://example.com", source: "Naukri", recruiter: "dev@futwork.com"}
                    ]
                }
            case MATCH_AGENT:
                fileName = 'onboarding_upload_agents_to_match'
                return {
                    headers: defaultSchema,
                    data: [
                        {mobile: "9123456786"}
                    ]
                }
            case BULK_MODERATION_MANUAL_GRADES:
                fileName = 'bulk_moderation_with_manual_grades'
                return {
                    headers: [...defaultSchema, 
                        {label: "scriptPreparedness", key: "scriptPreparedness"},
                        {label: "pronunciation", key: "pronunciation"},
                        {label: "tonality", key: "tonality"},
                        {label: "speed", key: "speed"}
                    ],
                    data: [
                        {mobile: "9123456786", scriptPreparedness: "A",
                            pronunciation: "A", tonality: "A", speed: "A"
                        }

                    ]
                }
            default:
                return defaultSchema
        }
    }

    const tableHeaders = getSchema().headers && 
        getSchema().headers.map(item => {
        const key = item.key
        const isMandatory = !optionalHeaders.includes(key)
        item = { name: key, mandatory: isMandatory }
        return item
    })

    return (
        <div className={styles.display_schema}>
            <div className={styles.form_label}>The CSV should have the defined schema</div>
            <table className={styles.headers_table}>
                <tr>
                    {
                        tableHeaders.map(header => {
                            return <th className={styles.headers_list}>{header.name}{header.mandatory ? <span className={styles.mandatory}>*</span> : null}</th>
                        })
                    }
                </tr>
            </table>
            <CSVLink headers={getSchema().headers}
            data={getSchema().data}
                filename={`${fileName}.csv`}
            >
                <div className={styles.download_btn}>
                    <CustomTooltip placement={'bottom'} component={<img title="Download Template" src={DownloadIcon} alt='download' />}
                        description={'Download the schema as csv'} />
                </div>
            </CSVLink>
        </div>
    )
}

export default CSVSchema